import React from "react";

const PeopleDashboard = () => {
  return <div>PeopleDashboard</div>;
};

export default PeopleDashboard;
